'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSxAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28.0002 10H0.00016276L0 20H28L28.0002 10Z", fill: "#0740AA" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0L0.00016276 10H28.0002L28 0Z", fill: "#F02C33" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L13.3333 10L0 20V0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.00016 9.33333V7.34153C2.00016 6.60215 2.58455 6 3.32735 6H6.00631C6.74123 6 7.3335 6.60968 7.3335 7.34153V9.33333C7.3335 10.4594 6.8211 11.2622 5.9955 11.73C5.51845 12.0003 5.0523 12.1091 4.62248 12.1319C4.28136 12.1091 3.81521 12.0003 3.33815 11.73C2.51256 11.2622 2.00016 10.4594 2.00016 9.33333Z",
          fill: "#E72C33"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.66683 9.33333V7.34153C2.66683 6.96881 2.9545 6.66667 3.32735 6.66667H6.00631C6.37111 6.66667 6.66683 6.97615 6.66683 7.34153V9.33333C6.66683 11.3333 4.66683 11.4667 4.66683 11.4667C4.66683 11.4667 2.66683 11.3333 2.66683 9.33333Z",
          fill: "#78C1F0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.00016 8.66667L4.66683 8L5.3335 8.66667V10H4.00016V8.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33518 12.4907C2.14271 13.4213 3.41504 14 4.66682 14C5.93084 14 7.22056 13.4026 8.02819 12.4511C8.26646 12.1704 8.23207 11.7497 7.95137 11.5115C7.67068 11.2732 7.24997 11.3076 7.0117 11.5883C6.45731 12.2414 5.53923 12.6666 4.66682 12.6666C3.80087 12.6666 2.89614 12.2552 2.34225 11.6168C2.10094 11.3387 1.67989 11.3089 1.40179 11.5502C1.1237 11.7915 1.09388 12.2126 1.33518 12.4907Z",
          fill: "#F9D835"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.66683 7.33333C5.40321 7.33333 6.00016 6.73638 6.00016 6C6.00016 5.26362 5.40321 4.66667 4.66683 4.66667C3.93045 4.66667 3.3335 5.26362 3.3335 6C3.3335 6.73638 3.93045 7.33333 4.66683 7.33333Z",
          fill: "#F7E14B"
        }
      )
    ]
  }
);
const VpFlagSxAsset = forwardRef(FlagSxAsset);

export { VpFlagSxAsset as default };
